import { gql } from 'graphql-tag'

const defaultShiftResponsibilityFragment = gql`
  fragment DefaultShiftResponsibilityFragment on ShiftResponsibility {
    id
    name
    isEnabled
    station {
      id
      name
    }
  }
`

export const fetchChainShiftResponsibilities = gql`
  query FetchChainShiftResponsibilities($isEnabled: Boolean) {
    chainShiftResponsibilities(isEnabled: $isEnabled) {
      id
      name
      isEnabled
    }
  }
`

export const fetchStationShiftResponsibilities = gql`
  query FetchStationShiftResponsibilities($stationId: ID!, $isEnabled: Boolean) {
    stationShiftResponsibilities(stationId: $stationId, isEnabled: $isEnabled) {
      ...DefaultShiftResponsibilityFragment
    }
  }
  ${defaultShiftResponsibilityFragment}
`

export const createShiftResponsibilityMutation = gql`
  mutation CreateShiftResponsibility($name: String!, $isEnabled: Boolean, $stationId: ID) {
    createShiftResponsibility(name: $name, isEnabled: $isEnabled, stationId: $stationId) {
      ...DefaultShiftResponsibilityFragment
    }
  }
  ${defaultShiftResponsibilityFragment}
`

export const updateShiftResponsibilityMutation = gql`
  mutation UpdateShiftResponsibility($id: ID!, $name: String!, $isEnabled: Boolean) {
    updateShiftResponsibility(id: $id, name: $name, isEnabled: $isEnabled) {
      ...DefaultShiftResponsibilityFragment
    }
  }
  ${defaultShiftResponsibilityFragment}
`

export const deleteShiftResponsibilityMutation = gql`
  mutation DeleteShiftResponsibility($id: ID!) {
    deleteShiftResponsibility(id: $id)
  }
`
